import React, { Component } from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
class Body extends Component {
    constructor(props, context) {
        super(props, context);
    }

    getBranchName = (id) => {
        return this.props.userBranch[id - 1].name;
    }

    render() {
        const theYear = this.props.searchedYear == null ? moment().format('YYYY') : this.props.searchedYear;
        const theBranch = this.props.searchedBranch == null ? this.getBranchName(this.props.loggedBranch) : this.props.searchedBranch;

        return (
            <div className="table-responsive">
                <div className="mt-5">
                    {/* YEAR SUMMARY BOX */}
                    <div className="row m-0 mt_xs">
                        <div className="col-lg-2 col-md-2"></div>
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <div className="row m-0 green_box col-4-p-0 col-4-em-0 ptb-30">
                                <div className="sales_label_container">
                                    <label className="label_big_title">TOTAL {theYear}</label>
                                    <p>{theBranch}</p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-3 m-0 p-0 text-center in_green_box">
                                    <div><b>POS Orders</b></div>
                                    <h2 className="p-0 m-0 text-muted"><b>{this.props.shoppingTrend.corecount}</b></h2>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-5  m-0 p-0 pt-2 in_green_box">
                                    <div><b>POS Gross Sales</b></div>
                                    <h2 className="p-0 m-0 money">{getDollarFormat(this.props.shoppingTrend.coresales)}</h2>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 in_green_box">
                                    <div><b>POS Percentage</b></div>
                                    <h2 className="p-0 m-0 money">{this.props.shoppingTrend.corepercentage ? this.props.shoppingTrend.corepercentage.toFixed(2) : 0}%</h2>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-3 m-0 p-0 text-center in_green_box">
                                    <div><b>Online Orders</b></div>
                                    <h2 className="p-0 m-0 text-muted"><b>{this.props.shoppingTrend.onlinecount}</b></h2>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-5  m-0 p-0 pt-2 in_green_box">
                                    <div><b>Online Gross Sales</b></div>
                                    <h2 className="p-0 m-0 money">{getDollarFormat(this.props.shoppingTrend.onlinesales)}</h2>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 in_green_box">
                                    <div><b>Online Percentage</b></div>
                                    <h2 className="p-0 m-0 money">{this.props.shoppingTrend.onlineprecentage ? this.props.shoppingTrend.onlineprecentage.toFixed(2) : 0}%</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2"></div>
                    </div>
                    {/* LIST - Months */}
                    <div className="row m-0">
                        {
                            this.props.shoppingTrend && this.props.shoppingTrend.list && this.props.shoppingTrend.list.length > 0 && this.props.shoppingTrend.list.map((item, index) => {
                                return (
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" key={index}>
                                        <div className="row m-0 green_box min_height_120">
                                            <div className="sales_label_container"><label>{item.month}</label></div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-3 m-0 p-0 text-center in_green_box">
                                                <div><b>POS Orders</b></div>
                                                <h2 className="p-0 m-0 text-muted"><b>{item.coreCount}</b></h2>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-5  m-0 p-0 pt-2 in_green_box">
                                                <div><b>POS Gross Sales</b></div>
                                                <h2 className="p-0 m-0 money">{getDollarFormat(item.coresales)}</h2>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 in_green_box">
                                                <div><b>POS Percentage</b></div>
                                                <h2 className="p-0 m-0 money">{item.corepercentage ? item.corepercentage.toFixed(2) : 0}%</h2>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-3 m-0 p-0 text-center in_green_box">
                                                <div><b>Online Orders</b></div>
                                                <h2 className="p-0 m-0 text-muted"><b>{item.onlinecount}</b></h2>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-5  m-0 p-0 pt-2 in_green_box">
                                                <div><b>Online Gross Sales</b></div>
                                                <h2 className="p-0 m-0 money">{getDollarFormat(item.onlinesales)}</h2>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 in_green_box">
                                                <div><b>Online Percentage</b></div>
                                                <h2 className="p-0 m-0 money">{item.onlineprecentage ? item.onlineprecentage.toFixed(2) : 0}%</h2>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }

}
export default Body;